import API from "shared/services/Api";
import {
  IListPendingResponse,
  IUpdateStatusResponse,
  IResendResponse,
  IHistoryResponse,
  IVerifyStatusResponse,
  IAlertsResponse,
  IVerifyAllResponse,
  IUpdateStatusPayload,
} from "shared/types/ReferralTracking";

/**
 * Lista solicitações/encaminhamentos pendentes, expirados e realizados de um paciente
 */
export const getPatientReferralStatus = async (
  pacienteId: number,
  userId: string
): Promise<IListPendingResponse> =>
  API.get(`oc/referrals/patient/${pacienteId}/pending?id=${userId}`);

/**
 * Atualiza o status de um formulário (marcar como realizado ou cancelado)
 */
export const updateReferralStatus = async (
  formId: number,
  data: IUpdateStatusPayload,
  userId: string
): Promise<IUpdateStatusResponse> =>
  API.put(`oc/referrals/form/${formId}/status?id=${userId}`, data);

/**
 * Cria um reenvio de um formulário existente
 */
export const resendReferral = async (
  formId: number,
  userId: string
): Promise<IResendResponse> =>
  API.post(`oc/referrals/form/${formId}/resend?id=${userId}`, {});

/**
 * Obtém o histórico completo de um formulário (incluindo reenvios)
 */
export const getReferralHistory = async (
  formId: number,
  userId: string
): Promise<IHistoryResponse> =>
  API.get(`oc/referrals/form/${formId}/history?id=${userId}`);

/**
 * Verifica automaticamente o status de um formulário baseado no tipo
 */
export const verifyReferralStatus = async (
  formId: number,
  userId: string,
  autoUpdate: boolean = false
): Promise<IVerifyStatusResponse> =>
  API.get(
    `oc/referrals/form/${formId}/verify?id=${userId}&auto_update=${autoUpdate ? "1" : "0"}`
  );

/**
 * Obtém alertas de formulários pendentes/expirados para um paciente
 */
export const getReferralAlerts = async (
  pacienteId: number,
  userId: string
): Promise<IAlertsResponse> =>
  API.get(`oc/referrals/patient/${pacienteId}/alerts?id=${userId}`);

/**
 * Verifica e atualiza automaticamente todos os formulários pendentes de um paciente
 */
export const verifyAllPendingReferrals = async (
  pacienteId: number,
  userId: string
): Promise<IVerifyAllResponse> =>
  API.post(`oc/referrals/patient/${pacienteId}/verify-all?id=${userId}`, {});

